import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartCtx = createContext(null);
const KEY = "vvs_cart_v1";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            const raw = typeof window !== "undefined" ? localStorage.getItem(KEY) : null;
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    });
    const [open, setOpen] = useState(false);

    useEffect(() => {
        try {
            localStorage.setItem(KEY, JSON.stringify(items));
        } catch {}
    }, [items]);

    const add = useCallback((item) => {
        setItems((prev) => {
            const idx = prev.findIndex(
                (p) => p.product_id === item.product_id && p.variant_id === item.variant_id && (p.finition || "") === (item.finition || "")
            );
            if (idx >= 0) {
                const clone = [...prev];
                clone[idx] = { ...clone[idx], quantity: clone[idx].quantity + (item.quantity || 1) };
                return clone;
            }
            return [...prev, { ...item, quantity: item.quantity || 1 }];
        });
        setOpen(true);
    }, []);

    const remove = (product_id, variant_id, finition = "") =>
        setItems((prev) => prev.filter((p) => !(p.product_id === product_id && p.variant_id === variant_id && (p.finition || "") === finition)));

    const setQty = (product_id, variant_id, qty, finition = "") =>
        setItems((prev) =>
            prev
                .map((p) =>
                    p.product_id === product_id && p.variant_id === variant_id && (p.finition || "") === finition ? { ...p, quantity: qty } : p
                )
                .filter((p) => p.quantity > 0)
        );

    const clear = () => setItems([]);

    const subtotal = items.reduce((s, it) => s + it.price_cad * it.quantity, 0);
    const count = items.reduce((s, it) => s + it.quantity, 0);

    return (
        <CartCtx.Provider value={{ items, add, remove, setQty, clear, subtotal, count, open, setOpen }}>
            {children}
        </CartCtx.Provider>
    );
}

export const useCart = () => useContext(CartCtx);
